const zh = {
   login:{ 
      title:'我是标题',
   },
   app:{
      title: "乐天电子科技有限公司",
      one: "首页",
      two: "企业动态",
      three: "产品中心",
      four: "联系我们"
   },
   index:{
      title: "乐天精彩生活",
      subtitle: "邀你一起抵达每个奇妙瞬间",
      description: "发现生活小确幸，优乐佳与你共享美好时光",
      button: "立即参与",
      newProducts: "新产品预览",
      viewDetails: "查看详情",
      viewMore: "查看更多"
   },
   index_two:{
      title: "家居好物狂欢节",
      subtitle: "优乐佳生活小用品特惠专场",
      description: "精选100+实用家居好物，限时8折起",
      button: "立即抢购",
   },
   case:{
      h1: "联系我们",
      address: "地址：",
      addressDes: "中国广东省四会市东城街道上元塘地段",
      photo: "手机：",
      people1: "邹女士：",
      people2: "陈女士：",
      people3: "陈先生：",
      p:"关注微信公众号"
   },
   news:{
      p1: "四会市乐天电子科技有限公司成立于2004年，十九年来始终专注创意小家电研发、设计、生产和销售一体化服务。",
      p2: "我们坚持从概念设计到生产制造全流程自主把控，拥有成熟的产品落地能力。通过严谨的品控体系和深度加工制造，确保为消费者提供可信赖的优质产品。",
      p3: "公司以「场景化创新」为核心战略，产品设计融合科技感与年轻化美学，涵盖智能家居、个人护理、生活电器等领域。持续洞察Z世代消费群体在不同生活场景中的需求，致力于提供具有设计美学的创新解决方案。",
      p4: "创新基因 | 年轻主张 | 品质坚守",
      t0: "公司简介",
      t1: "企业文化",
      t2: "发展历程",
      t3: "文化优势",
      t4: "工作环境",
      t5: "企业荣誉",
      t6: "加入我们",
      button: "立即加入"
   },
   product:{
      h1: "产品中心",
      price: "价格: ",
      sale: "销量: ",
      ku: "库存: 99",
      h3: "购买电话",
      h4: "在线留言",
      photo: "您的电话",
      name: "您的姓名",
      button: "立即提交",
      underConstruction: "产品内容正在建设中..."
   },
   productDetail:{
      price: "价格",
      number: "数量",
      promotion: "优惠券",
      promotionDes: "满299减30",
      color: "选择颜色",
      standard: "产品参数",
      addToCart: "加入购物车",
      button: "立即购买" 
   },
   footer:{
      name0: "优乐侍",
      name1: "制造商：",
      name2: "四会市乐天电子科技有限公司",
      name3: "厂址：",
      name4: "广东省四会市东城街道上元塘地段",
      name5: "扫码关注我们",
      name6: "法律声明",
      name7: "法律声明｜备案号｜粤ICP备20005346号",
      name8: "©2023 四会市乐天电子科技有限公司 版权所有",
      followOfficialAccount: "关注公众号",
      headquarterAddress: "总部地址：广东省肇庆市四会东城街道黄岗居委会新盛路2号",
      branchAddress: "分公司地址：广州白云区尖彭路喜聚中心A栋2楼203号"
   },
   nav: {
      home: "首页",
      products: "产品中心",
      about: "关于我们",
      news: "新闻动态",
      service: "服务与支持",
      join: "加入乐天",
      find: "找到乐天",
      language: "中文/EN",
      
      // 产品中心子菜单
      fanSeries: "风扇系列",
      lampSeries: "台灯系列",
      nightLight: "小夜灯系列",
      mosquitoLamp: "灭蚊灯系列",
      humidifier: "加湿器系列",
      heater: "暖风机系列",
      handWarmer: "暖手宝系列",
      ipSeries: "IP系列",
      
      // 关于我们子菜单
      brandIntro: "品牌简介",
      history: "发展历程",
      video: "品牌视频",
      honors: "企业荣誉",
      
      // 新闻动态子菜单
      exhibition: "展会资讯",
      companyNews: "企业动态",
      
      // 服务与支持子菜单
      contactUs: "联系我们",
      
      // 加入乐天子菜单
      socialRecruitment: "社会招聘",
      campusRecruitment: "校园招聘",
      internalReferral: "内部推荐"
   },
   recruitment: {
      title: "人才招聘",
      arrow: ">",
      location: "工作地点",
      salary: "薪资范围",
      applyNow: "立即申请",
      apply: "申请",
      name: "姓名",
      phone: "联系电话",
      email: "电子邮箱",
      resume: "简历上传",
      cancel: "取消",
      submit: "提交申请",
      officeEnv: "办公环境",
      lab: "现代化研发实验室",
      cafe: "员工休闲咖啡吧",
      workshop: "智能化生产车间",
      testLab: "材料检测实验室",
      meetingRoom: "多功能会议室",
      gym: "员工健身房",
      showroom: "产品展示厅",
      garden: "园区绿化环境",
      jobOpenings: "招聘职位",
      frontendDev: "前端开发工程师",
      uiDesigner: "UI设计师",
      shenzhen: "深圳",
      frontendDesc: "负责公司前端项目开发，参与产品需求讨论和技术方案设计。",
      uiDesc: "负责公司产品的界面设计，参与设计规范的制定和维护。",
      applySuccess: "的申请已提交成功!"
   },
   album: {
      yearTitle: "2025·新篇章",
      brandBook: "品牌宣传册", 
      slogan: "优雅你的生活美学",
      pdfName: "2025-乐天产品综合画册.pdf"
   },
   service: {
      title: "联系我们",
      hq: "肇庆总部",
      branch: "广州分公司",
      phone: "服务热线",
      email: "服务邮箱",
      address: "公司地址"
   }
}
export default zh;